"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.policyDetailsFromSegments = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const merge_1 = require("./merge");
function policyDetailsFromSegments(policy, { activeSegmentsOnly = false } = {}) {
    const policyDetails = (0, lodash_clonedeep_1.default)(policy.segments[0]);
    for (let i = 1; i < policy.segments.length; i += 1) {
        if (activeSegmentsOnly && (0, dayjs_1.default)(policy.segments[i].startDate).isAfter((0, dayjs_1.default)())) {
            // Ignore any segments that start in the future if `activeSegmentsOnly` is true
            continue;
        }
        if ((0, dayjs_1.default)(policy.segments[i].startDate).isAfter(policy.endDate)) {
            // ignore any renewal segments
            continue;
        }
        (0, merge_1.mergeAndRemoveDuplicates)(policyDetails, policy.segments[i]);
    }
    if (policyDetails.premium) {
        // we don't want the segment details premium to override policy.premium
        // and we copy the elements here to the root of policy
        delete policyDetails.premium;
    }
    return policyDetails;
}
exports.policyDetailsFromSegments = policyDetailsFromSegments;
//# sourceMappingURL=policy-details-from-segments.js.map